    import Vue from "vue";
    import Vuetify from "vuetify/lib/framework";
    import "@fortawesome/fontawesome-free/css/all.css";

    Vue.use(Vuetify);

    export default new Vuetify({
        icons: {
            iconfont: "fa",
        },
        theme: {
            dark: false,
            default: "light",
            themes: {
                light: {
                    primary: "#006b7d",
                    secondary: "#455A64",
                    accent: "#0097A7",
                    error: "#f44336",
                    warning: "#ffeb3b",
                    info: "#8E24AA",
                    success: "#4caf50",
                    // WCAG Compliant Color Additions for Light Theme
                    primary_wcag: "#005f6c",
                    bg_red: "#ba2525",
                    bg_green: "#0e8514",
                    bg_grey: "#575757",
                    ws_red: "#D32F2F",
                    ws_red_lighten_1: "#a62525",
                    ws_green: "#2E7D32",
                    ws_green_lighten_1: "#2E7D32",
                    ws_grey: "#3f463f",
                    content_title: "#0F172A",
                    content_p: "#212529",
                    call_content: "#1D4ED8",
                    put_content: "#75630B",
                    // Field Headings
                    sub_heading: "#694A4A",
                    // Tab Colors
                    tab_active_bg: "#e3e3e3",
                    tab_active_text: "#0033a9",
                    tab_inactive_bg: "#fefefe",
                    tab_inactive_text: "#666666",
                    // Strategy Types
                    btn_bullish_outlined_text: "#1B5E20",
                    btn_bearish_outlined_text: "#B71C1C",
                    btn_nondirectional_outlined_text: "#212121",
                    // Strategy Card
                    strategy_card_p: "#183341",
                    // Highlights
                    bg_max_highlight: "#9DDEAE",
                    max_highlight_p: "#1f612f",
                    bg_min_highligt: "#de9d9d",
                    max_highlight: "#611f1f",
                    // Option Chain ATM Row
                    atm_row: "#dfffaf",                    
                    call_check: "#3549ff",
                    put_check: "#b89318",
                    //buttons
                    active_b: "#006c7a",
                    //backtesting
                    bac_title:"#4e4d4d",
                    //chip
                    chip_purple:'#CE93D8',
                    chip_tela: "#26A69A",
                    chip_orange: "#FF8A65",
                    chip_green: "#66BB6A",
                    chip_lime: "#D4E157",
                    bearish_card: "#FFCDD2",
                    bullish_card: "#C8E6C9",
                    neutral_card: "#CFD8DC", 
                    //table
                    table_header:'#00357a',
                    // NEW: OI & Volume Colors
                    oi_gainer: "#005C65",
                    oi_loser: "#E30066",
                    volume_buzzers: "#50007A",
                },
                dark: {
                    primary: "#006b7d",
                    secondary: "#455A64",
                    accent: "#0097A7",
                    error: "#f44336",
                    warning: "#ffeb3b",
                    info: "#8E24AA",
                    success: "#4caf50",
                    // WCAG Compliant Color Additions for Dark Theme
                    primary_wcag: "#005f6c",
                    bg_red: "#ba2525",
                    bg_green: "#127617",
                    bg_grey: "#575757",
                    ws_red: "#ff5959",
                    ws_red_lighten_1: "#ff7c7c",
                    ws_green: "#60ea66",
                    ws_grey: "#c9e4c9",
                    content_title: "#F1F5F9",
                    content_p: "#F8F9FA",
                    call_content: "#85bcff",
                    put_content: "#FBBF24",
                    // Field Headings
                    sub_heading: "#d99c9c",
                    // Tab Colors
                    tab_active_bg: "#212121",
                    tab_active_text: "#00D4FF",
                    tab_inactive_bg: "#2b2a2a", // #424242
                    tab_inactive_text: "#BDBDBD",
                    // Strategy Types
                    btn_bullish_outlined_text: "#81C784",
                    btn_bearish_outlined_text: "#EF5350",
                    btn_nondirectional_outlined_text: "#E0E0E0",
                    // Strategy Card
                    strategy_card_p: "#87b1c7",
                    // Highlights
                    bg_max_highlight: "#1f612f",
                    max_highlight_p: "#5dff78",
                    bg_min_highligt: "#611f1f",
                    max_highlight: "#de9d9d",
                    // Option Chain ATM Row
                    atm_row: "#3f4d16",
                    call_check: "#9da6ff",
                    put_check: "#00ff2e",
                    //buttons
                    active_b: "#0096a9",
                    //backtesting
                    bac_title:"#afaeae",
                    //chip
                    chip_purple:'#a11ff1',
                    chip_tela: "#00695C",          // Teal
                    chip_orange: "#BF360C",       // Deep Orange
                    chip_green: "#2E7D32",           // Green
                    chip_lime: "#827717",            // Olive
                    bearish_card: "#4A1F24",
                    bullish_card: "#1B5E20",
                    neutral_card: "#37474F",
                    //table
                    table_header:'#64B5F6',
                    // NEW: OI & Volume Colors (Dark Theme Variants)
                    oi_gainer: "#00B8CC",
                    oi_loser: "#FF66B3",
                    volume_buzzers: "#B366FF",
                },
            }
        },
    });